<template>
  <div class="campsite-reviews-summary-txt">
    <translate tag="h3">What customers say</translate>
    <p class="summary-txt">{{ summaryTxt }}</p>
    <p class="footnote">
      <img src="@/assets/images/ai-icon.svg" width="16" height="16" />
      <translate
        >Summary AI-generated from Pitchup.com customer reviews</translate
      >
    </p>
  </div>
</template>
<script setup lang="ts">
defineProps<{
  summaryTxt: String
}>()
</script>

<style scoped>
div {
  border-radius: var(--border-radius);
  border: 2px solid var(--colour-page-background-light);
  padding: 0.75em 1em;
  margin: 1em 0;
  max-width: 50ch;
}

h3 {
  color: var(--colour-dark-blue);
  font-size: 1em;
}

.summary-txt {
  line-height: 1.35;
}

.campsite-reviews-summary-txt .footnote {
  color: var(--colour-wcag-blue);
  font-size: var(--tiny);
  display: flex;
  align-items: start;
  gap: 0.3em;
  line-height: 1.1;
}
</style>
